module.exports = __webpack_public_path__ + "static/media/1.827a5d17.jpg";